<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody
                                ><CTabs variant="tabs" :active-tab="0">
                                    <!--  Tab General -->
                                    <CTab :title="$t('General')">
                                        <CContainer class="mt-3" fluid>
                                            <CRow>
                                                <CCol sm="12">
                                                    <GeneralSegmentForm
                                                        ref="generalSegmentForm"
                                                        :formData="segment"
                                                    ></GeneralSegmentForm>
                                                </CCol>
                                            </CRow>
                                        </CContainer>
                                    </CTab>
                                    <CTab
                                        :title="$t('Builder')"
                                        :disabled="!segment.uuid"
                                    >
                                        <QueryBuilderForm
                                            ref="queryBuilderForm"
                                            :formData="{
                                                query: JSON.parse(
                                                    segment.query
                                                ),
                                            }"
                                        />
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave @click="save" />
                                <ButtonBack />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonSave from "~/components/ButtonSave";
import ButtonBack from "£lement/ButtonBack";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";

export default {
    name: "SegmentsViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin],
    components: {
        ButtonSave,
        ButtonBack,
        GeneralSegmentForm,
        QueryBuilderForm,
    },
    data() {
        return {
            segment: {
                uuid: null,
                name: null,
                query: "{}",
                description: null,
            },
        };
    },
    computed: {
        viewType: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.params.uuid ? this.$route.params.uuid : null;
        },
    },
    methods: {
        async loadSegment() {
            const resp = await this.fetcher({
                url: `/segmentations/segments/${this.uuid}`,
                baseURL: process.env.VUE_APP_API_SASS,
                method: "GET",
            });
            this.segment = resp.data;
        },
        async save() {
            this.updatePageLoading(true);
            try {
                const generalSegmentForm = this.$refs.generalSegmentForm;
                const formData = generalSegmentForm.getFormData();
                const queryBuilderForm = this.$refs.queryBuilderForm;
                
                const { query } = queryBuilderForm.getFormData();
                
                if (this.uuid) {
                    this.provider = await this.fetcher({
                        url: `/segmentations/segments/${this.uuid}`,
                        method: "PUT",
                        baseURL: process.env.VUE_APP_API_SASS,
                        data: {
                            ...formData,
                            query: JSON.stringify(query),
                        },
                    });
                } else {
                    this.provider = await this.fetcher({
                        url: `/segmentations/segments`,
                        method: "POST",
                        baseURL: process.env.VUE_APP_API_SASS,
                        data: formData,
                    });
                }

                this.showMessageSuccess();

                this.$router.go(-1);
            } catch (error) {
                this.showMessageError(error);
                this.updatePageLoading(false);
            }
        },
    },
    async mounted() {
        if (this.uuid) await this.loadSegment();
        this.updatePageLoading(false);
    },
};
</script>

<style></style>
